import React from 'react';

import DoneOutlinedIcon from '@material-ui/icons/DoneOutlined';
import DoneAllOutlinedIcon from '@material-ui/icons/DoneAllOutlined';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import MotorcycleOutlinedIcon from '@material-ui/icons/MotorcycleOutlined';
import CheckCircleOutlinedIcon from '@material-ui/icons/CheckCircleOutlined';
import BlockOutlinedIcon from '@material-ui/icons/BlockOutlined';
import LocalMallOutlinedIcon from '@material-ui/icons/LocalMallOutlined';

import { Container } from './styles';

function OrderStatus({ order }) {
  const { status, modality } = order;
  return (
    <Container>
      {status === 'created' && (
        <>
          <DoneOutlinedIcon />
          <span>Pedido criado</span>
        </>
      )}

      {status === 'received' && (
        <>
          <DoneAllOutlinedIcon />
          <span>Pedido recebido</span>
        </>
      )}

      {status === 'accepted' && (
        <>
          <DescriptionOutlinedIcon />
          <span>Pedido aceito</span>
        </>
      )}

      {status === 'delivery' && (
        <>
          {modality === 0 && <MotorcycleOutlinedIcon />}
          {modality === 1 && <LocalMallOutlinedIcon />}
          {modality === 0 && <span>Pedido saiu para entrega</span>}
          {modality === 1 && <span>Pedido pronto para retirada</span>}
        </>
      )}

      {status === 'concluded' && (
        <>
          <CheckCircleOutlinedIcon />
          <span>Pedido concluido</span>
        </>
      )}

      {status === 'canceled' && (
        <>
          <BlockOutlinedIcon />
          <span>Pedido cancelado</span>
        </>
      )}
    </Container>
  );
}

export { OrderStatus };
